import { create } from "zustand";

type Notification = {
  msg: string;
  imageUrl?: string;
  duration: number;
  channel?: string;
};

type NotificationStore = {
  notifications: Notification[];
  rewardNotification?: Notification;
  addNotification: (message: string, imageUrl?: string, duration?: number, channel?: string) => void;
  clearNotifications: (channel?: string) => void;
  addRewardNotification: (message: string, duration?: number) => void;
  removeFirst: () => void;
  clearRewardNotification: () => void;
};

export const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [],
  addNotification: (message: string, imageUrl?: string, duration = 2.5, channel?: string) =>
    set((state) => ({
      notifications: [...state.notifications, { msg: message, imageUrl, duration, channel }],
    })),
  clearNotifications: (channel?: string) =>
    set((state) => ({ notifications: state.notifications.filter((x) => x.channel !== channel) })),
  addRewardNotification: (message: string, duration = 8) =>
    set(() => ({
      rewardNotification: { msg: message, duration },
    })),
  removeFirst: () => set((state) => ({ notifications: state.notifications.slice(1) })),
  clearRewardNotification: () => set(() => ({ rewardNotification: undefined })),
}));
